const UsersRoutes = {
  resetPassword: "/users/resetpassword",
  addEmployeeBulk: "/users/addBulk",
  getUserByID: "/users/getbyid",
  addEmployee: "/users/create",
  getEmployee: "/users",
  updateEmployee: "/users/update",
};

export default UsersRoutes